<template lang="pug">
  .form
    form(id="postForm" method="post")
      input(type="hidden" id="amount" name="amount" value="")
      input(type="hidden" id="bankID" name="bankID" value="")
      input(type="hidden" id="orderID" name="orderID" value="")
      input(type="hidden" id="shopID" name="shopID" value="")
      input(type="hidden" id="randomKey" name="randomKey" value="")
      input(type="hidden" id="signature" name="signature" value="")

</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID;
    },
    sessionToken() {
      return this.$store.getters.sessionToken;
    },
    appID() {
      return config.app_id;
    }
  },
  created() {
    var q = this.$route.query;
    this.paymentGateWaySubmit(q.amount, q.bank, q.promo);
  },
  methods: {
    paymentGateWaySubmit(deposit_amount, target_bank_id, package_id) {
      if(package_id === '0'){
        package_id = ""
      }  
      if (this.accountID && this.sessionToken && this.appID) {
        let account_id = this.accountID;
        let auth_token = this.sessionToken;
        let app_id = config.app_id;
        this.$store
          .dispatch("user/iBankTransfer", {
            account_id,
            deposit_amount,
            target_bank_id,
            package_id,
            auth_token,
            app_id
          })
          .then(response => {
            this.feedback.success = response.success;
            this.feedback.status = response.status;
            if (this.feedback.success == true) {
              $("#amount").val(response.data[0].amount);
              $("#bankID").val(response.data[0].bankid);
              $("#orderID").val(response.data[0].orderid);
              $("#shopID").val(response.data[0].shopid);
              $("#randomKey").val(response.data[0].randomkey);
              $("#signature").val(response.data[0].signature);
              $("#postForm").attr("action", response.data[0].urlpaymentgateway);
              $("#postForm").submit();
            } else {
              var vm = this;
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false;
            this.feedback.success = false;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status);
          });
      }
    }
  }
};
</script>
